import PropTypes from "prop-types";
import { useRef } from "react";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";

import { MONTH_DATE_YEAR_FORMAT } from "utils/date";
import { DateTimePickerContainer, DatePickerGlobalStyles } from "./Form.styles";
import { IconCalendar } from "assets/icons/index";

export const DateTimePicker = ({ label, placeholder, id, name, ...props }) => {
  const datePickerRef = useRef(null);

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };
  return (
    <>
      <DatePickerGlobalStyles />
      <DateTimePickerContainer>
        <Form.Group>
          {label && <Form.Label>{label}</Form.Label>}
          <DatePicker
            ref={datePickerRef}
            dateFormat={MONTH_DATE_YEAR_FORMAT}
            placeholderText={placeholder}
            customInput={
              <input
                id={id}
                name={name}
                className="form-control filter-form-control"
              />
            }
            showMonthDropdown
            showYearDropdown
            dropdownMode="scroll"
            {...props}
          />
          <IconCalendar className="calendar-icon" onClick={handleIconClick} />
        </Form.Group>
      </DateTimePickerContainer>
    </>
  );
};

DateTimePicker.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
};
